var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 5.33333,
    fill: "#F7F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 23.25H23",
    stroke: "#6277FF",
    strokeWidth: 1.13514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9733 13.0342H11.4598C10.6239 13.0342 9.94629 13.7118 9.94629 14.5477V19.0882C9.94629 19.9241 10.6239 20.6017 11.4598 20.6017H12.9733C13.8092 20.6017 14.4868 19.9241 14.4868 19.0882V14.5477C14.4868 13.7118 13.8092 13.0342 12.9733 13.0342Z",
    stroke: "#6277FF",
    strokeWidth: 1.13514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5407 9.25H19.0272C18.1913 9.25 17.5137 9.92762 17.5137 10.7635V19.0878C17.5137 19.9237 18.1913 20.6014 19.0272 20.6014H20.5407C21.3766 20.6014 22.0542 19.9237 22.0542 19.0878V10.7635C22.0542 9.92762 21.3766 9.25 20.5407 9.25Z",
    stroke: "#6277FF",
    strokeWidth: 1.13514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartIcon);
export default __webpack_public_path__ + "static/media/barChartIcon.b9996d4837589d37e3994802795475db.svg";
export { ForwardRef as ReactComponent };